export const APP_PIN_LEN = 4;
export const APP_PIN_MIN_LEN = APP_PIN_LEN;
export const APP_PIN_MAX_LEN = APP_PIN_LEN;
export const APP_PIN_PBKDF2_ITERATIONS = 100_000;
export const APP_PIN_HASH_VERSION = 1;
export const APP_PIN_LOCKOUT_AFTER = 5;
export const APP_PIN_LOCKOUT_MS = 20_000;

export const APP_PIN_FIRESTORE_FIELD = 'appPinLock';

export function isValidAppPin(pin: string): boolean {
  return /^\d{4}$/.test(pin);
}
